export default `
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform vec3 uColor4;
uniform vec4 uColorMap;
uniform vec2 uAlphaMapVector;
uniform vec4 uGradient;

uniform vec2 uResolution;
uniform float uTime;
uniform float uAlpha;
uniform vec4 uProgress;
uniform float uBlurRangeMin;

varying vec2 vIndex;
varying float vX;

float parabola(float t){
  return -pow(2.0 * t - 1.0, 2.0) + 1.0;
}

float convertNormal(float minT, float maxT, float t){
  return max(0.0, min(1.0, (t - minT) / (maxT - minT)));
}

// float calcProgress(float p, float index, float pOffset){
//   float _progress = mix(-pOffset, 1.0 + pOffset, p);
//   return smoothstep(-pOffset * (1.0 - index), 1.0 + pOffset * index, _progress);
// }

vec4 calcProgress(vec4 p, float index, vec4 pOffset){
  vec4 _p = mix(-pOffset, 1.0 + pOffset, p);
  return smoothstep(vec4(index), vec4(index) + pOffset, _p);
}

float calcProgress(float p, float index, float pOffset){
  float _p = mix(-pOffset, 1.0 + pOffset, p);
  return smoothstep(index, index + pOffset, _p);
}

void main(){
  vec4 progress = calcProgress(uProgress, vIndex.x, vec4(0.05, 0.6, 0.1, 0.1));
  vec2 st = gl_FragCoord.xy / uResolution;

  float alpha = pow(1.0 - abs((vX - 0.5) * 2.0), 2.0);
  alpha = smoothstep(uBlurRangeMin, 1.0, alpha) * uAlpha;

  alpha *= mix(uAlphaMapVector.x, 1.0, convertNormal(uGradient.x, uGradient.y, vIndex.x));
  alpha *= mix(1.0, uAlphaMapVector.y, convertNormal(uGradient.z, uGradient.w, vIndex.x));
  alpha *= progress.x;
  alpha *= mix(parabola(vIndex.x), 1.0, uProgress.z);

  vec3 color = mix(vec3(0.2), vec3(1.0), progress.y);

  if(alpha < 0.001) discard;


  gl_FragColor = vec4(color, alpha);
}`
